import Vue from 'vue'

const run = (request) => {
  return Vue.prototype.$http.post('troubleshoot', request)
}

export default {
  run,
}
